export type GetGeneralCodesRequest = {
  cdTypes: string[];
};
